import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type FileSizeUnit = 'B' | 'KB' | 'MB';

@Pipe({
	name: 'fileSize',
	standalone: true,
	pure: false
})
export class FileSizePipe implements PipeTransform {
	constructor(private readonly translate: TranslateService) {}

	private readonly unitToKey: Record<FileSizeUnit, string> = {
		B: 'FILE_SIZE_B',
		KB: 'FILE_SIZE_KB',
		MB: 'FILE_SIZE_MB'
	};

	transform(
		bytes: number | null | undefined,
		mode: 'auto' | 'kb' | 'mb' = 'auto'
	): string | null {
		if (bytes == null || !Number.isFinite(bytes) || bytes < 0) {
			return null;
		}

		let value: number;
		let unit: FileSizeUnit;

		if (mode === 'kb') {
			value = bytes / 1024;
			unit = 'KB';
		} else if (mode === 'mb') {
			value = bytes / (1024 * 1024);
			unit = 'MB';
		} else if (bytes < 1024) {
			value = bytes;
			unit = 'B';
		} else if (bytes < 1024 * 1024) {
			value = bytes / 1024;
			unit = 'KB';
		} else {
			value = bytes / (1024 * 1024);
			unit = 'MB';
		}

		const unitLabel = this.translate.instant(this.unitToKey[unit]);

		return `${value.toFixed(1)} ${unitLabel}`;
	}
}